import type { BundleMessage, WithRequired } from '@ms-cloudpack/common-types';
import type { InitPackageIdentifier } from './InitPackageIdentifier.js';
import type { BundleInfo } from '@ms-cloudpack/api-server';

export interface InitPackageResult extends InitPackageIdentifier {
  errors?: BundleMessage[];
  warnings?: BundleMessage[];
  info?: BundleInfo;
  /** Absolute path for the bundle output */
  outputPath?: string;
}

export type InitPackageResultWarnings = WithRequired<InitPackageResult, 'warnings'>;
export type InitPackageResultErrors = InitPackageResult & Required<Pick<InitPackageResult, 'errors'>>;
